import React from "react";
import { getStories } from "../../api";
import axios from "axios";
import severUrl from "../../api";

class ASR extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stories: []
        };
    }

    componentDidMount() {
        var bodyFormData = new FormData();
        bodyFormData.append("topic_id", 2);
        axios.post(severUrl + "blog/post/story/", bodyFormData).then((response) => {
            this.setState({ stories: response.data })
            console.log(response)
        })
    }

    render() {
        return (
            <>
                <p style={{fontWeight:"bold"}}>ASR (Automatic Speech Regcognnition)</p>
                <p className="simple-text-md">Automatic Speech Recognition is subfield of Computer Sciences and it similar with transform the speech signal into text with purpose searching</p>
                <p className="simple-text-md">The topics related to ASR task</p>
                <ul style={{display:"list-item", content: "• ", listStyleType:"circle"}}>
                    <li>Speech feature with Lirbi dataset</li>
                    <li>Key spot detection with Transformer</li>
                    <li>Neural Language Model in Speech Recognition</li>
                    <li>Speech Emotion Recognition</li>
                </ul>
                {
                    this.state.stories.map((item, i) => {
                        return (
                            <p>
                                <a
                                    style={
                                        {
                                            fontSize: "22px",
                                            fontWeight: "0.4"
                                        }
                                    }
                                    href={`/${item.slug}`}>{item.title}</a>
                            </p>
                        );
                    })
                }
            </>
        );
    }
}

export default ASR;
